<template>
    <div>
        <AppSidebar />

        <div class="wrapper d-flex flex-column min-vh-100">
            <AppHeader
                @getVacation="getVacation"
                @getDayOff="getDayOff"
                @showEvent="showEvent"
            />
            <div class="position-relative body flex-grow-1 px-3">
                <CContainer xxl>
                    <router-view :key="$route.fullPath" />
                </CContainer>
            </div>

            <GetVacationModal
                @getVacation="getVacation"
                :showModal="showVacation"
                @closeVacationModal="showVacation = false"
            />
            <GetDayOffModal
                @getDayOff="getDayOff"
                :showModal="showDayOff"
                @closeDayOffModal="showDayOff = false"
            />

            <EventModal
                @showEvent="showEvent"
                :showModal="showModal"
                :eventType="eventType"
                :eventData="event"
                @closeEventModal="showModal = false"
            />

            <AppFooter />
        </div>
    </div>
</template>
<script>
import { CContainer } from '@coreui/vue'
import AppFooter from '@/components/base/AppFooter.vue'
import AppHeader from '@/components/base/AppHeader.vue'
import AppSidebar from '@/components/base/AppSidebar.vue'
import GetVacationModal from '@/components/vacation/GetVacationModal.vue'
import GetDayOffModal from '@/components/vacation/GetDayOffModal.vue'
import EventModal from '@/components/hr/EventModal.vue'

export default {
    name: 'DefaultLayout',
    emits: [
        'getVacation',
        'getDayOff',
        'showEvent',
        'closeVacationModal',
        'closeDayOffModal',
        'closeEventModal',
    ],
    components: {
        AppFooter,
        AppHeader,
        AppSidebar,
        CContainer,
        GetVacationModal,
        GetDayOffModal,
        EventModal,
    },
    data() {
        return {
            showVacation: false,
            showDayOff: false,
            showModal: false,
            eventType: '',
            event: {},
        }
    },
    mounted() {
        this.$store.dispatch('users/getEmployees')
        this.$store.dispatch('users/getAllUsersList')
        this.$store.dispatch('reports/setCurrentInfo').then(() => this.isLoaded = true)
    },
    methods: {
        getVacation() {
            this.showVacation = !this.showVacation
        },
        getDayOff() {
            this.showDayOff = !this.showDayOff
        },
        showEvent(event, type) {
            this.eventType = type
            this.event = event
            this.showModal = !this.showModal
        },
    },
}
</script>
